const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const resolveMediaUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    
    // In production, VITE_API_URL might be "https://domain.com/api".
    // Public storage is usually at "https://domain.com/storage", not "https://domain.com/api/storage".
    const baseUrl = API_BASE.replace(/\/api\/?$/, '');
    
    // Ensure we don't have double slashes if the url already starts with /
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    
    return `${baseUrl}${cleanUrl}`;
};
